<section class="wrapper">
  <div #target class="tabs left">
    <div
      *ngFor="let config of tabConfig; let first = first"
      [attr.type]="config?.type"
      class="tab {{ first ? 'active' : '' }}"
    >
      {{ config?.name }}
    </div>
  </div>
</section>
